import { render, staticRenderFns } from "./HardwareGroupForm.vue?vue&type=template&id=4704affa"
import script from "./HardwareGroupForm.vue?vue&type=script&lang=js"
export * from "./HardwareGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports